import { c as _c } from "react/compiler-runtime";
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import useUser from 'shared/hooks/use-user';
import { isSIO } from 'shared/utils/is-sio';
export const growthbookClient = new GrowthBook({
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NODE_ENV === 'development'
});
interface GrowthbookClientProviderProps extends PropsWithChildren {
  currentPath: string;
}
export function GrowthbookClientProvider(t0) {
  const $ = _c(5);
  const {
    children,
    currentPath
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== currentPath) {
    t2 = [currentPath];
    $[1] = currentPath;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <GrowthBookProvider growthbook={growthbookClient}>{children}</GrowthBookProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2() {
  growthbookClient.setURL(window.location.href);
}
function _temp() {
  growthbookClient.init({
    skipCache: true,
    streaming: true
  });
}
export function useSyncGrowthbookUserAttributes() {
  const $ = _c(6);
  const {
    user,
    isWorkspaceOwner,
    isWsAdmin,
    isWsAssistant
  } = useUser();
  let t0;
  let t1;
  if ($[0] !== isWorkspaceOwner || $[1] !== isWsAdmin || $[2] !== isWsAssistant || $[3] !== user) {
    t0 = () => {
      if (!user) {
        return;
      }
      growthbookClient.setAttributes({
        id: user.id,
        roles: user.roles,
        userPlanId: user.userPlanId,
        country: user.country,
        isWorkspaceOwner,
        isWsAdmin,
        isWsAssistant,
        isSIO: isSIO()
      });
    };
    t1 = [isWorkspaceOwner, isWsAdmin, isWsAssistant, user];
    $[0] = isWorkspaceOwner;
    $[1] = isWsAdmin;
    $[2] = isWsAssistant;
    $[3] = user;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}